export default {
  address: 'ADDRESS',
  updateAddress: 'UPDATE_ADDRESS',
};
